import React from 'react';

import HorizontalThrobber from 'ui-library/HorizontalThrobber';

export default function ExpandedSidepanelThrobber(): JSX.Element {
  return (
    <div className="u-width-full text-center">
      <div className="u-small-padding">
        <HorizontalThrobber />
      </div>
    </div>
  );
}
